import { render, staticRenderFns } from "./Tab_layerassoc.vue?vue&type=template&id=31040725"
import script from "./Tab_layerassoc.vue?vue&type=script&lang=js"
export * from "./Tab_layerassoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports